export default {
  dict: {
    startUsing: '启用',
    disable: '禁用',
    currentChoice: '当前选择',
    filter: '输入字典关键字进行过滤',
    insertTitle: '新增字典',
    dictCode: '字典编码',
    dictCodePlaceholder: '请输入字典编码',
    dictName: '字典名称',
    dictNamePlaceholder: '请输入字典名称',
    dictType: '字典类型',
    dictTypePlaceholder: '请输入字典类型',
    dictNameTips: '建议英文名且需唯一 非开发人员谨慎修改',
    remark: '备注',
    dataStatus: '数据状态',
    remarkPlaceholder: '请输入备注',
    sortNo: '排序值',
    relationDictType: '关联字典类型',
    dictCodeNotEmpty: '字典编码不能为空',
    dictNameNotEmpty: '字典名称不能为空',
    dictTypeNotEmpty: '字典类型不能为空',
    sortNoNotEmpty: '排序值不能为空',
    editTitle: '编辑字典',
    dictDetail: '数据信息',
    editTips: '您还没选择要编辑的字典',
    deleteTips: '您还没选择要删除的字典',
    addDateTips: '您还没选择要添加的字典',
    table: {
      dataName: '名称',
      dataValue: '数据值',
      sortNo: '排序值',
      dataStatus: '状态',
      remark: '备注',
    },
    insertDataTitle: '添加字典',
    insertDataTitle2: '的数据',
    dataCode: '字典数据编码',
    dataCodePlaceholder: '请输入字典数据编码',
    dataName: '字典数据名称',
    dataNamePlaceholder: '请输入字典数据名称',
    dataValue: '字典数据值',
    dataValuePlaceholder: '请输入字典数据值',
    relationDictTypePlaceholder: '请输入关联字典类型',
    dataCodeNotEmpty: '字典数据编码不能为空',
    dataNameNotEmpty: '字典数据名称不能为空',
    dataValueNotEmpty: '字典数据值不能为空',
    editDataTitle: '编辑字典',
    deleteDictDataTips: '请选择一条记录进行删除',
  },
};
